import { render, staticRenderFns } from "./DiscountChartModal.vue?vue&type=template&id=31da57f6&scoped=true"
import script from "./DiscountChartModal.vue?vue&type=script&lang=js"
export * from "./DiscountChartModal.vue?vue&type=script&lang=js"
import style0 from "./DiscountChartModal.vue?vue&type=style&index=0&id=31da57f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31da57f6",
  null
  
)

export default component.exports